import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { SetMpinApi } from "../../../api/request/dashboard/dashboard";
import { setPopupShown, setUserDetails } from "../../../store/Slices/userSlice";

const MpinModal = ({
  isOpen,
  setIsOpen,
  updateMpin = false,
  closable = false,
  setShowIntialPopup,
  initialData,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { userDetails, isPopupShown } = useSelector((state) => state?.user);
  const [isMpinLoading, setIsMpinLoading] = useState(false);

  const handleSetMpin = async (values) => {
    try {
      setIsMpinLoading(true);
      const { data } = await SetMpinApi(values);
      if (data?.status) {
        dispatch(setUserDetails({ ...userDetails, mpin: true }));
        if (!initialData?.data?.total_files && !isPopupShown) {
          setShowIntialPopup(true);
          dispatch(setPopupShown(true));
        }
        setIsOpen(false);
        toast.success(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsMpinLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) form.resetFields();
  }, [isOpen]);

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={updateMpin ? "Reset Mpin" : "Set Mpin"}
      closable={closable}
    >
      <h4 className="mid-title text-gray-500 text-center">
        {`${
          updateMpin ? "Reset" : "Set"
        } a 6-digit MPIN to enhance your account security. This MPIN will be used to verify your identity during login.`}
      </h4>
      <Form form={form} onFinish={handleSetMpin}>
        <Form.Item
          name="mpin"
          rules={[{ required: true }]}
          className="flex justify-center"
        >
          <Input.OTP size="large" style={{ width: "100%" }} />
        </Form.Item>
        <LoadableButton
          isLoading={isMpinLoading}
          type="submit"
          lable={updateMpin ? "Reset Mpin" : "Set Mpin"}
          loadingLabel={updateMpin ? "Resetting MPIN..." : "Setting MPIN..."}
          className={"w-full mt-3"}
        ></LoadableButton>
      </Form>
    </ModalComponent>
  );
};

export default MpinModal;
